import React, { useState } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField, MenuItem, Grid } from '@material-ui/core';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getDriverOperations } from '../../../actions/driverActions';
import { getUserPreference } from '../../../utilities/common';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const useStyles = makeStyles((theme)=> ({
    root: {
        flexGrow: 1,
    }
}))

export default function ConditionalSearch(props) {
    const classes = useStyles();
    const {t} = useTranslation('editDriver');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    
    const [section,setSection] = useState('-1');
    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [searchDriverId,setSearchDriverId] = useState("");


    return (
        <Grid container spacing={2} style={{display: 'flex', flexDirection: 'row', padding: 16}}>
            <Grid item xs={2}>
                <TextField
                    id="edit_driver_record_from_date_textfield"
                    type="date"
                    variant="outlined"
                    value={dateFrom}
                    fullWidth
                    onChange={(e)=>setDateFrom(e.target.value)}
                    label={t('date_from')}
                /> 
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id="edit_driver_record_to_date_textfield"
                    type="date"
                    variant="outlined"
                    value={dateTo}
                    fullWidth
                    onChange={(e)=>setDateTo(e.target.value)}
                    label={t('date_to')}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    select
                    id="edit_driver_record_section_textfield"
                    label={t('sections_edited')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={section}
                    fullWidth
                    onChange={(e)=>{setSection(e.target.value);}}
                >
                    {
                        _.map(props.sectionList, (value, key) => (
                            <MenuItem key={key} value={key}>
                                {value.name}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id="edit_driver_record_driver_id_textfield"
                    label={t('driver_id')}
                    InputLabelProps={{ shrink: true }}                
                    variant="outlined"
                    value={searchDriverId}
                    fullWidth
                    onChange={(e)=>{setSearchDriverId(e.target.value);}}
                />
            </Grid>
            <Grid item xs={2}>
                <Button
                    color='primary'
                    onClick={handleSearch}
                    variant='contained'
                >
                    {t('search')}
                </Button>
            </Grid>
        </Grid>
    );

    function handleSearch() {
        dispatch(getDriverOperations({
            criteria: 'EDIT-PROFILE',
            warehouse_id: userPref.userCity,
            start_date: dateFrom,
            end_date: dateTo,
            data_type: section === '-1' ? null : section,
            driver_id: searchDriverId ? searchDriverId : null
        }))
        .catch(() => {
            dispatch(showAlertSnackbar({message:t('fetch_data_fail'),type:'error'}))
        })
    }
}
